var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64844 5.13867C2.64844 4.60824 2.85915 4.09953 3.23422 3.72446C3.6093 3.34939 4.118 3.13867 4.64844 3.13867H10.6484V21.1387H4.64844C4.118 21.1387 3.6093 20.928 3.23422 20.5529C2.85915 20.1778 2.64844 19.6691 2.64844 19.1387V5.13867ZM14.6484 3.13867H20.6484C21.1789 3.13867 21.6876 3.34939 22.0627 3.72446C22.4377 4.09953 22.6484 4.60824 22.6484 5.13867V10.1387H14.6484V3.13867ZM14.6484 14.1387H22.6484V19.1387C22.6484 19.6691 22.4377 20.1778 22.0627 20.5529C21.6876 20.928 21.1789 21.1387 20.6484 21.1387H14.6484V14.1387Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b4d46233ac700f51d59dfaf14dacaa37.svg";
export { ForwardRef as ReactComponent };